import React, { Dispatch, MouseEventHandler, SetStateAction, useState } from 'react';
import ReactDOM from 'react-dom';

class DoctorInfo {
    heading: string;
    hander: (visibility: boolean) => void;
    detailIsShown: boolean;
    link: string;
    imageClass: string;
    detailHeading: string;
    detailInfo: string;
    detailDoctor: string;
    phone: string;
    openingHours: () => JSX.Element;
}

class ActivityModel {
    name: string;
    description: JSX.Element;
}

export const Index = () => {
    const allActivities: Array<ActivityModel> = [
        { name: "Ordinace praktických lékařů", description: <a href='http://www.help-praktik-pardubice.cz/' target="_blank">http://www.help-praktik-pardubice.cz/</a>, },
        { name: "Interní ambulance", description: <a href='tel:606753365' target="_blank">606 753 365</a>, },
        { name: "Diabetologická ambulance", description: <a href='tel:776880033' target="_blank">776 880 033</a>, },
        { name: "EKG", description: <p>EKG Vám uděláme bez objednání kdykoli za čas  pracovní doby</p>, },
        {
            name: "Očkovací centrum", description:
                <React.Fragment>
                    <p>
                        Nabízíme několik druhů očkování, z nichž jedno z nejvyhledávanějších je očkování proti&nbsp;<span className='underline'>klíšťové
                            encefalitidě</span>. Tuto nabídku by měli využít aktivní lidé, kteří chodí často do přírody, sportují anebo
                        chodí na procházky s domácími mazlíčky. Očkování proti klíšťové encefalitidě je možné vykonat
                        kdykoliv během roku, nejen před začátkem období aktivity klíšťat. Ve věku od 50 let je toto
                        očkování hrazeno z&nbsp;veřejného zdravotního pojištění.
                    </p>
                    <p className="mt-4">
                        Dalším velmi častým typem očkování je očkování proti&nbsp;<span className='underline'>chřipce</span>. Chřipka není rýma, je to závažné
                        virové onemocnění, jež postiženého připoutá na lůžko s vysokou horečkou, bolestí svalů
                        a&nbsp;kloubů. Pro očkování proti chřipce jsou nejvhodnější měsíce září, říjen a listopad. Je určeno
                        dospělým, od 65 let je hrazeno z&nbsp;veřejného zdravotního pojištění.
                    </p>
                    <p className="mt-4">
                        Často využívaným typem očkování bývá i očkování proti <span className='underline'>pneumokokovým nákazám</span>. Toto
                        očkování je určeno dospělým od 50 roku věku s&nbsp;tím, že od 65 let je hrazeno z&nbsp;veřejného
                        zdravotního pojištění.
                    </p>
                    <p className="mt-4">
                        V současné době poskytujeme očkování proti <span className='underline'>COVID 19</span>, využíváme dostupné vakcíny,
                        schválené Českou vakcinologickou společností.
                    </p>
                    <p className="mt-4">
                        Dále nabízíme očkování proti virové <span className='underline'>hepatitidě typu A, B</span>
                    </p>
                    <p className="mt-4">
                        U všech typů očkování se řídíme platným očkovacím kalendářem.
                    </p>
                </React.Fragment>,
        },
        { name: "Centrum klinických studií", description: <></>, },
        { name: "Nutriční terapeut", description: <p>Nutriční specialistka Dis. Žáková s Vámi zhodnotí Váš jídelníček a po konzultaci s lékařem vhodně upraví Vaší stravovací jednotku s přihlédnutím k vaším nemocem, fyzickým možnostem a záměrům atd.</p> },
        {
            name: "Edukační centrum", description: <p>
                V budově Malé polikliniky sídlí registrované edukační pracoviště schválené Českou diabetologickou společností. Poskytuje služby jak individuální
                edukace tak skupinové edukace u diabetiků. Významným podílem na činnosti je edukace stran <a className='underline' href='http://www.diahelp-pardubice.cz/' target="_blank">těhotenské cukrovky</a>. Veškerá edukační činnost je přístupná i pro jiné ambulance
                vč. praktických lékařů. Spolupracujeme s klubem diabetiků.
            </p>,
        },
        {
            name: "Pracovní lékařství", description:
                <React.Fragment>
                    <p className='text-center mb-2'>V případě vyšetření v rámci PRACOVNĚ LÉKAŘSKÝCH SLUŽEB je bezpodmínečně nutné, aby měl pacient s sebou PLATNOU ŽÁDOST OD ZAMĚSTNAVATELE
                        (s razítkem, podpisem, údaji o zaměstnavateli, vykonávané profesi a především s jasným uvedením rizikové kategorie a u kategorie 2 a více jasným uvedením rizik).</p>
                    <p className='text-center mb-6'>
                        Smyslem pracovně-lékařské zdravotní prohlídky zaměstnance je zjistit jeho aktuální zdravotní stav a odborně posoudit, zda je pro jeho pracovní činnost nutno nastavit nějaká omezení. Cílem vyšetření je ochránit zdraví zaměstnance, rovněž tak jeho spolupracovníky a další osoby pohybující se v blízkosti. Jaké jsou druhy zdravotních prohlídek a podle čeho se určují lhůty a termíny opakování?
                    </p>
                    <p className='text-left mt-2'>
                        Práva a povinnosti týkající se pracovně-lékařských služeb jsou uvedeny ve třech hlavních právních předpisech:
                    </p>
                    <ul className='text-left list-disc list-inside mt-2'>
                        <li><span className='font-bold'>Zákon č. 373/2011 Sb.</span> o specifických zdravotních službách</li>
                        <li><span className='font-bold'>Zákon č. 202/2017 Sb.</span>, kterým se mění zákon č. 373/2011 Sb.</li>
                        <li><span className='font-bold'>Vyhláška č. 79/2013 Sb.</span> o provedení některých ustanovení zákona č. 373/2011 Sb., o specifických zdravotních službách</li>
                        <li><span className='font-bold'>Zákon č. 262/2006 Sb.</span> zákoník práce</li>
                    </ul>
                    <p className='text-left mt-4'>
                        <span className='font-bold'>Pracovnělékařské služby</span>  vyhodnocují vliv pracovního výkonu, prostředí a podmínek na zdraví každého zaměstnance. Slouží k posouzení zdravotní způsobilosti k práci.
                    </p>
                    <div className='text-left'>
                        <p className='mt-6'><span className='font-bold'>Jejich lhůty a termíny opakování</span> závisí na níže uvedených kritériích:</p>
                        <p className='mt-2 font-bold'>1. Kategorizace práce</p>
                        <p>
                            Práce zaměstnance se zařazuje do čtyř kategorií podle míry nebezpečí a rizika. Čím vyšší je kategorie (1. - 4.), tím je také vyšší riziko pracovního úrazu, což je důvod k tomu provádět lékařské prohlídky častěji.
                        </p>
                        <p className='mt-2 font-bold'>2. Riziko ohrožení zdraví</p>
                        <p>
                            Riziko ohrožení zdraví zaměstnance ( rovněž tak jeho okolí ) v rámci plnění pracovních úkolů je dalším kritériem pro stanovení termínu opakování periodické prohlídky zaměstnance.
                        </p>
                        <p className='mt-2 font-bold'>3. Věk zaměstnance</p>
                        <p>
                            Opakování lékařských prohlídek je závislé od věku zaměstnance. Rozděluje se na zaměstnance mladší 50 let a starší 50 let.
                        </p>
                        <p className='mt-6 font-bold'>Druhy pracovnělékařských prohlídek + lhůty a termíny</p>
                        <p className='mt-2 font-bold'>1. Vstupní prohlídka</p>
                        <p>
                            Provádí se před vznikem pracovního poměru tzn. musí být provedena před dnem, kdy zaměstnanec nastupuje do práce. Bude-li zaměstnanec při vstupní prohlídce shledán zdravotně nezpůsobilým, ke vzniku pracovního poměru nedojde.
                        </p>
                        <p className='mt-2 font-bold'>2. Periodická prohlídka</p>
                        <p>
                            Provádí se v pravidelných termínech, za účelem včasného zjištění změny zdravotního stavu zaměstnance, jež může být ovlivněn zdravotní náročností práce, popř. stárnutím lidského organizmu.
                        </p>
                        <p className='mt-2 font-bold'>3. Mimořádná prohlídka</p>
                        <p>
                            Provádí se na základě přesně definovaného požadavku zaměstnavatele.
                        </p>
                        <p className='mt-2 font-bold'>4. Výstupní lékařská prohlídka</p>
                        <p>
                            Provádí se před dnem ukončení pracovního poměru zaměstnance
                        </p>
                    </div>
                    <div className='mt-8'>
                        <p className='font-bold'>Termíny periodické prohlídky dle kategorie práce</p>
                        <table className="table-auto border-collapse border border-slate-400 mt-4 mx-auto">
                            <tbody>
                                <tr>
                                    <td className="border border-slate-300 px-4 py-2">1. kategorie</td>
                                    <td className="border border-slate-300 px-4 py-2">
                                        <p>1 x za 6 let u zaměstnance do 49 let věku</p>
                                        <p>1 x za 4 roky u zaměstnance, který dovršil 50 let věku</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-slate-300 px-4 py-2">2. kategorie</td>
                                    <td className="border border-slate-300 px-4 py-2">
                                        <p>1 x za 4 roky u zaměstnance do 49 let věku</p>
                                        <p>1 x za 2 roky u zaměstnance, který dovršil 50 let věku</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-slate-300 px-4 py-2">2. riziková kategorie</td>
                                    <td className="border border-slate-300 px-4 py-2">
                                        1 x za 2 roky bez ohledu na věk zaměstnance
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-slate-300 px-4 py-2">3. kategorie</td>
                                    <td className="border border-slate-300 px-4 py-2">
                                        1 x za 2 roky bez ohledu na věk zaměstnance
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-slate-300 px-4 py-2">4. kategorie</td>
                                    <td className="border border-slate-300 px-4 py-2">
                                        1 x ročně bez ohledu na věk zaměstnance
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
        }
    ];

    const [showHelp, setShowHelp] = useState<boolean>(undefined);
    const [showDia, setShowDia] = useState<boolean>(undefined);

    const openingHtmlDia = () => (
        <div className='w-full'>
            <div className='w-96 mt-10 m-auto text-sm md:text-md'>
                <h3 className='font-medium'>Otevírací doba (* pro zvané)</h3>
                <div className='grid grid-cols-7'>
                    <div>PO</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>15:30</div>
                    <div className='col-span-3'></div>
                    <div>ÚT</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>15:30</div>
                    <div className='col-span-3'></div>
                    <div>ST</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>15:30</div>
                    <div className='text-right'>*15:30</div>
                    <div>-</div>
                    <div className='text-left'>17:00</div>
                    <div>ČT</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>15:30</div>
                    <div className='col-span-3'></div>
                    <div>PÁ</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>14:00</div>
                    <div className='col-span-3'></div>
                </div>
            </div>
        </div>
    );

    const openingHtmlHelp = () => (
        <div className='w-full'>
            <div className='w-96 mt-10 m-auto text-sm md:text-md'>
                <h3 className='font-medium'>Otevírací doba - akutně nemocní (* pro zvané)</h3>
                <div className='grid grid-cols-7'>
                    <div>PO</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>9:00</div>
                    <div className='text-right'>*9:00</div>
                    <div>-</div>
                    <div className='text-left'>14:00</div>
                    <div>ÚT</div>
                    <div className='text-right'>10:00</div>
                    <div>-</div>
                    <div className='text-left'>12:00</div>
                    <div className='text-right'>*12:00</div>
                    <div>-</div>
                    <div className='text-left'>18:00</div>
                    <div>ST</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>10:00</div>
                    <div className='text-right'>*10:00</div>
                    <div>-</div>
                    <div className='text-left'>15:00</div>
                    <div>ČT</div>
                    <div className='text-right'> </div>
                    <div> </div>
                    <div className='text-left'> </div>
                    <div className='text-right'>*7:00</div>
                    <div>-</div>
                    <div className='text-left'>14:00</div>
                    <div>PÁ</div>
                    <div className='text-right'>7:00</div>
                    <div>-</div>
                    <div className='text-left'>10:00</div>
                    <div className='text-right'>*10:00</div>
                    <div>-</div>
                    <div className='text-left'>14:00</div>
                </div>
            </div>
        </div>
    );

    const doctors: Array<DoctorInfo> = [
        {
            heading: "HELPPRAKTIK", phone: "+420 466 303 775", hander: setShowHelp, detailIsShown: showHelp, link: "http://www.help-praktik-pardubice.cz/", openingHours: openingHtmlHelp, imageClass: "help-thumbnail",
            detailHeading: "VŠEOBECNÝ PRAKTICKÝ LÉKAŘ", detailDoctor: "MUDr. Judita Kolešová, MUDr. Nikola Pechová",
            detailInfo: "Všeobecný praktický lékař (VPL) vždy byl a je pro své pacienty rádcem a manažerem ve využívání specializovaných zdravotních a sociálních služeb, jeho úkolem je poskytnout léčebně-preventivní péči, zajistit návaznost odborných doporučení. Mezi základní služby poskytované VPL patří: konzultační, diagnostická a léčebná činnost při akutních problémech, pravidelná péče o pacienty s chronickými chorobami, preventivní činnost včetně screeningu a očkování, posudková činnost pracovnělékařská, sociální a sportovní, návštěvní služba."
        }
        , {
            heading: "DIAHELP", phone: "776 880 033", hander: setShowDia, detailIsShown: showDia, link: "http://www.diahelp-pardubice.cz/vitejte", openingHours: openingHtmlDia, imageClass: "help-diahelp",
            detailHeading: "ODBORNÁ DIABETOLOGICKÁ A INTERNÍ AMBULANCE", detailDoctor: "MUDr. Juraj Divinec",
            detailInfo: "Naše ambulance se zaměřuje na diagnostiku a léčbu vnitřních nemocí, diabetu mellitu, obesity, poruch metabolismu a civilisačních chorob v širším pohledu. Naším cílem je poskytnout komplexní péči o pacienty s přihlédnutím k jejich individuálním potřebám. Neustále sledujeme vývoj nových léčebných preparátů a postupů. Tyto znalosti poté využíváme k nastavení nejúčinnější léčby každého pacienta."
        }
    ]

    return (
        <React.Fragment>
            <div className="w-full text-center md:text-left">
                <div className="w-full xl:w-full inline-block text-black mt-3 py-6 px-12 text-center">
                    <h1 className="text-4xl text-center">Vítejte na stránkách Malé polikliniky</h1>
                    <p className="mt-5 md:w-2/3 w-full m-auto">
                        Malá poliklinika je projekt nabízející komplexní lékařskou péči. V budově se v aktuální chvíli nachází interní ambulance, diabetologická ambulance a ambulance praktických lékařů.
                        Na čem si zakládáme? Na profesionálním, přátelském a skromném přístupu.
                    </p>
                    <p className='mt-5 md:w-2/3 w-full m-auto'>
                        Personál Malé polikliniky sice dokáže kvalifikovaně plnit úkoly s nejmodernější lékařskou technikou, ale chápe, že pacienti nejsou stroje.
                    </p>
                </div>
                <h2 className='text-3xl text-center mt-10 text-mainBlue font-medium'>ORDINACE</h2>
                <div className='w-full mt-3 py-6 md:px-12 grid grid-cols-1 xl:grid-cols-2 justify-items-center'>
                    {doctors.map(i => (
                        <div className='w-full md:w-4/5 relative mt-8 xl:m-0'>
                            <div className='bg-mainBlue relative h-full flex overflow-hidden'>
                                <div className='absolute z-10 partOverlayLeft'></div>
                                <div className='absolute z-10 partOverlayTop'></div>
                                <div className='absolute z-10 partOverlayBottom'></div>
                                <div className='absolute z-10 partOverlayRight'></div>
                                <div className={'bg-gray-500 m-auto text-center text-2xl overlayParent py-32 z-20 relative w-19/20 h-9/10 ' + i.imageClass}
                                    onMouseEnter={() => i.hander(true)} onMouseLeave={() => i.hander(false)}>
                                    <div className="text-left text-2xl md:text-4xl 2xl:text-6xl mt-4 px-4 pb-6 text-center font-bold tracking-custom">
                                        <p className='fontShadow'>{i.heading}</p>
                                    </div>
                                    <div className="overlay flex items-center">
                                        <a href={i.link} target="_blank" className="m-auto px-5 py-2 border border-white text-xl text-white font-bold">Více</a>
                                    </div>
                                </div>
                            </div>
                            <div className={'w-full absolute p-4 bg-white text-black transition animationPrep duration-500 text-center ' + (i.detailIsShown == undefined ? 'animationPrep' : i.detailIsShown ? 'slide-in' : 'slide-out')} >
                                <h3 className='text-xl font-medium mb-1'>{i.detailHeading}</h3>
                                <p className='text-lg font-italic mb-2'>{i.detailDoctor}</p>
                                <p className='text-lg font-italic mb-4'>{i.phone}</p>
                                <p className='text-sm font-medium text-justify'>
                                    {i.detailInfo}
                                </p>
                                {i.openingHours()}
                            </div>
                        </div>
                    ))}
                </div>
                <div className='text-left px-4 md:px-24 mb-16 mt-6 text-black font-medium'>
                    <h2 className='text-xl mb-12 text-mainBlue text-center'>Jaké služby u nás najdete?</h2>
                    <div className='m-auto text-center flex flex-col items-center'>
                        {allActivities.map(activity =>
                        (
                            <ActivityComponent name={activity.name}>
                                {activity.description}
                            </ActivityComponent>
                        )
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const ActivityComponent = (props) => {
    const [show, setShow] = useState<boolean>(undefined);

    return (
        <div className='inline-block w-full 2xl:w-1/2 p-4 bg-mainBlue text-white font-black text-xl rounded-xl my-2 drop-shadow-xl hover:bg-mainBlueHover duration-500 cursor-pointer overflow-hidden' onClick={_ => setShow(!show)}>
            {props.name}
            <div className={'text-sm font-medium actionAnimationPrep px-2 2xl:px-4 ' + (show == undefined ? '' : show ? "mt-4 slideDown" : "slideUp")}>{props.children}</div>
        </div>
    )
}

ReactDOM.render(<Index></Index>, document.getElementById('index'));